<div class="container my-5" *ngIf="infoMessage">
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-5">
      <ui-message [type]="infoMessage.type">
        {{infoMessage.text}}
      </ui-message>
    </div>
  </div>
</div>

<div class="container my-5" *ngIf="paymentIntent && !infoMessage">
  <div class="my-5">
    <payment-request-details
        [paymentIntent]="paymentIntent"
        [webhookUrlPrefix]="webhookUrlPrefix"
        (onPaymentError)="paymentErrorProcess($event)"
    ></payment-request-details>
  </div>

  <div class="row justify-content-center">
    <div class="col-lg-8 col-md-10">
      <unified-order-info-table
          *ngIf="paymentIntent"
          [paymentIntent]="paymentIntent"
          [isCustomerView]="true"
          (onShowMap)="onShowMap.emit()"
      ></unified-order-info-table>
    </div>
  </div>
</div>

<div class="container my-5" *ngIf="paymentIntent && infoMessage">
  <div class="row justify-content-center">
    <div class="col-lg-8 col-md-10">
      <unified-order-info-table
          *ngIf="paymentIntent"
          [order]="paymentIntent.order"
          (onShowMap)="onShowMap.emit()"
      ></unified-order-info-table>
    </div>
  </div>
</div>

